import { styled } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';

export const StyledRecaptcha = styled(ReCAPTCHA)(({ theme }) => ({
  margin: theme.spacing(-2, 0, 2, 0),
}));
